import React, { useState, useEffect } from "react"
import { Container, Button, Row } from "reactstrap"
import QRCode from "qrcode.react"
import Spinner from "../Spinner"
import htmlToImage from "html-to-image"
import download from "downloadjs"
import { jsPDF } from "jspdf"
import html2canvas from "html2canvas"
import { Link } from "react-router-dom"

const APIserver = "https://hdform.herokuapp.com/api/facility/"

const QRPage = (props) => {
  const [qrValue, setQrValue] = useState([])
  const [loading, setLoading] = useState(false)

  function getQRData() {
    fetch(APIserver + props.match.params.id)
      .then((res) => res.json())
      .then((res) => {
        console.log(res)
        setQrValue(res)
        setLoading(false)
      })
  }

  function printQR() {
    const input = document.getElementById("facilityQr")
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png")
      const pdf = new jsPDF("p", "mm", "a4")

      const imgProps = pdf.getImageProperties(imgData)
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width

      pdf.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight)
      pdf.save(
        `${qrValue.name}-${qrValue.code}-${new Date().getMilliseconds()}.pdf`
      )
    })
  }

  function saveAsImage() {
    const canvas = document.getElementById("facilityQr")
    htmlToImage.toPng(canvas).then(function (dataUrl) {
      download(
        dataUrl,
        `${qrValue.name}-${qrValue.code}.-${new Date().getMilliseconds()}.png`
      )
    })
  }

  useEffect(() => {
    setLoading(true)
    getQRData()
  }, [])

  return (
    <Container>
      {loading === true ? (
        <Spinner />
      ) : (
        <Container>
          <div className="qr-page-back-btn">
            <Link to="/admin">
              <Button color="secondary">Back</Button>
            </Link>
          </div>
          <Container id="facilityQr" className="qr-code">
            <Container className="fqr">
              <h3>Scan Me!</h3>
              <QRCode
                bgColor="#ffffff"
                fgColor="#341f97"
                size={250}
                value={`https://app-hdform.now.sh/form/${qrValue.id}`}
                renderAs="canvas"
                level="L"
                className="img-responsive container-fluid qr-code"
                includeMargin={true}
              />
              <p>{qrValue.id}</p>
              <p>Please scan this QR before entering our premises</p>
              <a href="https://hdform/now.sh">https://hdform/now.sh</a>
            </Container>
          </Container>
          <Container className="text-center">
            <p className="info-padding-top">
              Print and display this QR in the entrance of your business, office
              or home. This is the QR that your visitor is going to scan.
            </p>
          </Container>
          <div className="qr-btn-center">
            <Button color="primary" onClick={printQR}>
              Print
            </Button>
            <Button color="info" onClick={saveAsImage}>
              Save as Image
            </Button>
          </div>
        </Container>
      )}
    </Container>
  )
}

export default QRPage
